(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["first-order-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePopup = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('[data-popup-dialog]');
      const openButtons = root.querySelectorAll('[data-popup-open]');
      const closeButtons = root.querySelectorAll('[data-popup-close]');
      const capture = root.querySelector('[data-popup-capture]');
      const success = root.querySelector('[data-popup-success]');
      const copyButton = root.querySelector('[data-popup-copy]');
      const code = root.querySelector('[data-popup-code]');
      const serverStateNode = root.querySelector('[data-popup-server-state]');
      const delay = Math.max(0, Number(root.dataset.delay) || 6) * 1000;
      const repeatDays = Math.max(1, Number(root.dataset.repeatDays) || 7);
      const storageKey = root.dataset.storageKey;
      let serverState = {};

      if (!dialog) return;

      if (serverStateNode) {
        try {
          serverState = JSON.parse(serverStateNode.textContent);
        } catch (error) {
          serverState = {};
        }
      }

      const readState = () => {
        try {
          return JSON.parse(localStorage.getItem(storageKey)) || {};
        } catch (error) {
          return {};
        }
      };

      const writeState = (state) => {
        try {
          localStorage.setItem(storageKey, JSON.stringify(state));
        } catch (error) {
          return;
        }
      };

      const showSuccess = () => {
        if (capture) capture.hidden = true;
        if (success) success.hidden = false;
      };

      const openDialog = () => {
        if (dialog.open) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      };

      const closeDialog = () => {
        const state = readState();
        writeState({ ...state, dismissedAt: Date.now() });
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      };

      openButtons.forEach((button) => button.addEventListener('click', openDialog));
      closeButtons.forEach((button) => button.addEventListener('click', closeDialog));

      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
        if (outside) closeDialog();
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
      });

      if (copyButton && code) {
        copyButton.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(code.textContent.trim());
            copyButton.textContent = copyButton.dataset.copiedLabel;
          } catch (error) {
            return;
          }
        });
      }

      const state = readState();

      if (serverState.success) {
        writeState({ converted: true, convertedAt: Date.now() });
        showSuccess();
        openDialog();
        return;
      }

      if (state.converted) showSuccess();

      if (serverState.error) {
        openDialog();
        return;
      }

      const repeatWindow = repeatDays * 24 * 60 * 60 * 1000;
      const canAutoOpen = !state.dismissedAt || Date.now() - state.dismissedAt > repeatWindow;
      const designMode = window.Shopify && window.Shopify.designMode;

      if (!state.converted && (canAutoOpen || designMode)) {
        window.setTimeout(openDialog, designMode ? 300 : delay);
      }
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-first-order-popup]').forEach(initializePopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
